const config: Record<string, string> = {
	all: 'All',
	consulting: 'Consulting',
	development: 'Development',
	nda: 'NDA',
};

export default config;
